import { useState } from 'react';
import { CTAModal } from './CTAModal';

export function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<'trial' | 'contact' | 'line'>('trial');

  const openModal = (type: 'trial' | 'contact' | 'line') => {
    setModalType(type);
    setIsModalOpen(true);
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/0713ac6fbbda3d46dbfc5d0873ee442a.jpg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 text-center px-4 py-20 max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight drop-shadow-lg">
          定期テストの点数が上がる塾
        </h1>
        
        <p className="text-sm md:text-xl text-white mb-4 leading-relaxed drop-shadow-md">
          勉強習慣・提出物・内申点、すべてサポート
        </p>
        
        <p className="text-base md:text-lg text-white/90 mb-10 leading-relaxed drop-shadow-md">
          廿日市市大野の学習塾NICK 個別指導と集団指導のハイブリッド
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={() => openModal('trial')}
            className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-base md:text-lg px-8 py-4 rounded-full shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-calendar-check-line mr-2"></i>
            無料体験を申し込む
          </button>
          
          <button 
            onClick={() => openModal('contact')}
            className="bg-white hover:bg-gray-100 text-blue-600 font-bold text-base md:text-lg px-8 py-4 rounded-full shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-mail-line mr-2"></i>
            まずは相談する
          </button>
          
          <a 
            href="https://lin.ee/Od9tigSF"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white font-bold text-base md:text-lg px-8 py-4 rounded-full shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap w-full sm:w-auto text-center"
          >
            <i className="ri-chat-3-line mr-2"></i>
            LINEで質問する
          </a>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-6 text-white">
          <div className="flex items-center gap-2">
            <i className="ri-phone-line text-2xl"></i>
            <span className="text-lg font-bold">0829-78-1638</span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-white/50"></div>
          <div className="text-sm">
            平日 16:00-21:00 / 土曜 14:00-20:00
          </div>
        </div>
      </div>

      <CTAModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        type={modalType}
      />
    </section>
  );
}
